<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <div class="h-input-group" v-width="320">
          <DatePicker v-model="params.start" style="width: 130px" :clearable="false" :option="{end:params.end}"
                      format="YYYY-MM-DD"></DatePicker>
          <span class="h-input-addon">至</span>
          <DatePicker v-model="params.end" style="width: 130px" :clearable="false" :option="{start:params.start}"
                      format="YYYY-MM-DD"></DatePicker>
        </div>
      </Cell>
      <Cell>
        <input type="text" v-model="params.keyword" v-width="200" placeholder="事由/收款人"
               @keyup.enter="doSearch">
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button color="primary" icon="fa fa-refresh" @click="loadList">刷新</Button>
        <Button color="primary" @click="add">新增费用单据</Button>
        <Button @click="doExport">导出</Button>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="billList" :border="true" :loading="loading">
        <TableItem title="日期" prop="billDate" :width="110"></TableItem>
        <TableItem title="事由" prop="reason" :width="180"></TableItem>
        <TableItem title="类型" prop="type" :width="90"></TableItem>
        <TableItem title="结算方式" prop="settleType" :width="100"></TableItem>
        <TableItem title="单据金额(含税)" :width="130" align="right">
          <template slot-scope="{data}">{{ data.amountWithTax | numFormat }}</template>
        </TableItem>
        <TableItem title="可抵税额" :width="110" align="right">
          <template slot-scope="{data}">{{ data.deductTax | numFormat }}</template>
        </TableItem>
        <TableItem title="单据金额(不含税)" :width="140" align="right">
          <template slot-scope="{data}">{{ withoutTax(data) | numFormat }}</template>
        </TableItem>
        <TableItem title="收款人" prop="payee" :width="100"></TableItem>
        <TableItem title="部门" prop="department" :width="100"></TableItem>
        <TableItem title="备注" prop="remark"></TableItem>
        <TableItem title="关联凭证" :width="90" align="center">
          <template slot-scope="{data}">
            <span class="h-tag h-tag-bg-blue" v-if="data.voucherId">已生成</span>
            <span v-else>-</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="150">
          <div class="actions" slot-scope="{data}">
            <span @click="generateVoucher(data)" v-if="!data.voucherId">生成凭证</span>
            <span @click="edit(data)">编辑</span>
            <span @click="remove(data)" v-if="!data.voucherId">删除</span>
          </div>
        </TableItem>
      </Table>
      <Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
                  @change="currentChange" small align="right"/>
    </div>

    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">费用单据</div>
      <Form ref="form" v-width="420" :labelWidth="130" :model="form" :rules="validationRules">
        <FormItem label="日期" prop="billDate">
          <DatePicker type="date" v-model="form.billDate" format="YYYY-MM-DD"></DatePicker>
        </FormItem>
        <FormItem label="事由" prop="reason">
          <input type="text" v-model="form.reason">
        </FormItem>
        <FormItem label="类型" prop="type">
          <Select v-model="form.type" :datas="typeList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="结算方式" prop="settleType">
          <Select v-model="form.settleType" :datas="settleList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="单据金额(含税)" prop="amountWithTax">
          <NumberInput :min="0" v-model="form.amountWithTax" @input="calcWithoutTax"></NumberInput>
        </FormItem>
        <FormItem label="可抵税额">
          <NumberInput :min="0" v-model="form.deductTax" @input="calcWithoutTax"></NumberInput>
        </FormItem>
        <FormItem label="单据金额(不含税)">
          <NumberInput :min="0" v-model="form.amountWithoutTax" :disabled="true"></NumberInput>
        </FormItem>
        <FormItem label="收款人" prop="payee">
          <input type="text" v-model="form.payee">
        </FormItem>
        <FormItem label="部门">
          <input type="text" v-model="form.department">
        </FormItem>
        <FormItem label="备注">
          <input type="text" v-model="form.remark">
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';
import {exportCsv} from '../../js/common/export-file';

const round2 = (val) => Math.round((Number(val) || 0) * 100) / 100;

const emptyForm = {
  billDate: null,
  reason: '',
  type: '差旅',
  settleType: '现金',
  amountWithTax: null,
  deductTax: 0,
  amountWithoutTax: 0,
  payee: '',
  department: '',
  remark: ''
};

export default {
  name: 'Expense',
  data() {
    return {
      billList: [],
      typeList: [
        {id: '差旅', name: '差旅'},
        {id: '办公', name: '办公'},
        {id: '招待', name: '招待'},
        {id: '其他', name: '其他'}
      ],
      settleList: [
        {id: '现金', name: '现金'},
        {id: '银行存款', name: '银行存款'}
      ],
      params: {
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD'),
        keyword: ''
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['billDate', 'reason', 'type', 'settleType', 'amountWithTax', 'payee']
      },
      showForm: false,
      loading: false
    }
  },
  methods: {
    withoutTax(data) {
      if (data.amountWithoutTax !== null && data.amountWithoutTax !== undefined) {
        return data.amountWithoutTax;
      }
      return round2((Number(data.amountWithTax) || 0) - (Number(data.deductTax) || 0));
    },
    calcWithoutTax() {
      this.form.amountWithoutTax = round2((Number(this.form.amountWithTax) || 0) - (Number(this.form.deductTax) || 0));
    },
    loadList() {
      this.loading = true;
      this.$api.invoice.expense.list(Object.assign({}, this.params, {
        page: this.pagination.page,
        size: this.pagination.size
      })).then(({data}) => {
        this.billList = data.results || data.records || data || [];
        this.pagination.total = data.total || 0;
      }).catch(() => {
        this.$Message.error('费用单据加载失败');
      }).finally(() => this.loading = false);
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    currentChange() {
      this.loadList();
    },
    add() {
      this.form = Object.assign({}, emptyForm, {billDate: moment().format('YYYY-MM-DD')});
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, emptyForm, data);
      this.calcWithoutTax();
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      this.calcWithoutTax();
      this.loading = true;
      let data = Object.assign({}, this.form, {
        billDate: moment(this.form.billDate).format('YYYY-MM-DD')
      });
      this.$api.invoice.expense[data.id ? 'update' : 'save'](data).then(() => {
        this.$Message('保存成功~');
        this.showForm = false;
        this.loadList();
      }).catch(() => {
        this.$Message.error('费用单据保存失败');
      }).finally(() => this.loading = false);
    },
    remove(data) {
      this.$Confirm('确认删除该费用单据？').then(() => {
        this.$api.invoice.expense.delete(data.id).then(() => {
          this.$Message('删除成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('删除失败');
        });
      });
    },
    generateVoucher(data) {
      this.$Confirm('确认为该费用单据生成凭证？').then(() => {
        this.loading = true;
        this.$api.invoice.expense.generateVoucher(data.id).then(() => {
          this.$Message('凭证生成成功~');
          this.loadList();
        }).catch(() => {
          this.$Message.error('凭证生成失败');
        }).finally(() => this.loading = false);
      });
    },
    doExport() {
      let headers = ['日期', '事由', '类型', '结算方式', '单据金额(含税)', '可抵税额', '单据金额(不含税)', '收款人', '部门', '备注'];
      let rows = this.billList.map(data => [
        data.billDate, data.reason, data.type, data.settleType, data.amountWithTax, data.deductTax,
        this.withoutTax(data), data.payee, data.department, data.remark
      ]);
      exportCsv('费用单据', headers, rows);
    }
  },
  mounted() {
    this.loadList();
  }
}
</script>
